import styled from '@emotion/styled';

import { FlowToken } from '../flow-arguments/FlowToken';
import { defaultTokenExamples } from '../flow-arguments/tokens';

import { useI18n } from '../../../hooks/useI18nFormatters';
import { useFlowToken } from '../../../store/flow-tokens/useFlowTokens.ts';

import { su } from '../../../theme/functions/su';
import { theme } from '../../../theme/theme';

import { TextSmall } from '../../../components/common/text/TextSmall';
import { useOptionContext } from '../../../components/list-box/ListBox';

export function TokenItem(props) {
  const { i18n } = useI18n();
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const { ref, option, state, item, value } = useOptionContext();

  const { flowToken } = useFlowToken({ flowTokenId: value.key });

  let formattedTokenValue;
  const tokenValue = value.context.tokenValue != null ? value.context.tokenValue : flowToken?.value;

  switch (flowToken?.type) {
    case 'image':
      formattedTokenValue = '';
      break;
    case 'boolean':
      formattedTokenValue =
        tokenValue != null
          ? i18n.messageFormatter(`common.${tokenValue}`)
          : i18n.messageFormatter('logic.boolean');
      break;
    default:
      formattedTokenValue = String(
        tokenValue ?? flowToken?.example ?? defaultTokenExamples[flowToken?.type],
      );
      break;
  }

  return (
    <TokenItem.Root
      {...option.optionProps}
      ref={ref}
      data-is-selected={option.isSelected}
      data-is-focused={option.isFocused}
      data-is-pressed={option.isPressed}
      data-is-disabled={option.isDisabled}
    >
      <TokenItem.NameWrapper>
        <FlowToken
          style={{ '--flow-token-max-width': '200px' }}
          size="large"
          label={item.textValue}
          token={flowToken}
          isValueTooltipDisabled={true}
        />
      </TokenItem.NameWrapper>
      <TokenItem.Value textAlign="end" color={theme.color.text_light}>
        {formattedTokenValue}
      </TokenItem.Value>
    </TokenItem.Root>
  );
}

export function LocalTokenItem(props) {
  const { i18n } = useI18n();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars -- intentionally unused
  const { ref, option, state, item, value } = useOptionContext();

  const token = value.context.token;
  let tokenValue;

  switch (token?.type) {
    case 'image':
      tokenValue = '';
      break;
    case 'boolean':
      tokenValue = i18n.messageFormatter('logic.boolean');
      break;
    default:
      tokenValue = String(token.example ?? defaultTokenExamples[token.type]);
      break;
  }

  return (
    <TokenItem.Root
      {...option.optionProps}
      ref={ref}
      data-is-selected={option.isSelected}
      data-is-focused={option.isFocused}
      data-is-pressed={option.isPressed}
      data-is-disabled={option.isDisabled}
    >
      <TokenItem.NameWrapper>
        <FlowToken
          style={{ '--flow-token-max-width': '200px' }}
          size="large"
          label={item.textValue}
          tokenKey={item.key}
          token={token}
          isValueTooltipDisabled={true}
        />
      </TokenItem.NameWrapper>
      <TokenItem.Value textAlign="end" color={theme.color.text_light}>
        {tokenValue}
      </TokenItem.Value>
    </TokenItem.Root>
  );
}

TokenItem.NameWrapper = styled.div`
  flex: 1 1 60%;
`;

TokenItem.Value = styled(TextSmall)`
  display: inline-block;
  padding-inline-start: ${su(1)};
  flex: 1 1 40%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

TokenItem.Root = styled.li`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 100%;
  min-height: ${su(5)};
  border-radius: ${theme.borderRadius.default};
  outline: 0;
  padding: 5px 10px;
  cursor: pointer;

  &[data-is-focused='true'],
  &:hover {
    background-color: ${theme.color.background_hover};
  }
`;
